/* Fiche couette (12 oct). Pas de fenetre « oreillers » apres l ajout au
   panier sur cette fiche : les packs Bundle X proposent deja les oreillers
   (choix de la cliente, 12 oct). La fenetre reste active sur les autres
   fiches. */
document.addEventListener('DOMContentLoaded', function () {
  var offre = window.YKUpsell;
  if (!offre || !offre.proposer) return;
  offre.proposer = function () { return false; };
});

/* Pack Famille : « soit … par personne » sous le prix du pack, qui se
   reconnait a son sous-titre commencant par « 2 couettes ». Le prix affiche
   par Bundle X sert de modele : meme devise, meme separateur decimal. Bundle X
   reecrit ses prix a chaque changement de taille, d ou l observateur ; on ne
   touche au texte que s il change, ce qui arrete la boucle. */
(function () {
  if (!window.MutationObserver) return;

  function moitie(texte) {
    var m = texte.match(/\d[\d\s.,]*/);
    if (!m) return null;
    var brut = m[0].replace(/\s/g, '');
    var dec = /[.,]\d{2}$/.test(brut) ? brut.slice(-3, -2) : '';
    var chiffres = brut.replace(/[^\d]/g, '');
    var cents = dec ? parseInt(chiffres, 10) : parseInt(chiffres, 10) * 100;
    if (!(cents > 0)) return null;
    var demi = Math.round(cents / 2);
    var rendu = Math.floor(demi / 100) + (dec || ',') + ('0' + (demi % 100)).slice(-2);
    return texte.replace(m[0], rendu + (/\s$/.test(m[0]) ? ' ' : '')).trim();
  }

  function majParPersonne() {
    var cartes = document.querySelectorAll('.bx-offer-wrap');
    for (var i = 0; i < cartes.length; i++) {
      var carte = cartes[i];
      var sous = carte.querySelector('.bx-offer-subtitle');
      var prix = carte.querySelector('.bx-offer-main > .bx-offer-items > .bx-offer-prices .bx-discounted-price');
      if (!sous || !prix || !/^\s*2 couettes/i.test(sous.textContent)) continue;
      var demi = moitie(prix.textContent);
      var ligne = carte.querySelector('.yk-per');
      if (!demi) { if (ligne) ligne.parentNode.removeChild(ligne); continue; }
      var txt = 'soit ' + demi + ' par personne';
      if (!ligne) {
        ligne = document.createElement('span');
        ligne.className = 'yk-per';
        (prix.closest('.bx-offer-prices') || prix.parentNode).appendChild(ligne);
      }
      if (ligne.textContent !== txt) ligne.textContent = txt;
    }
  }

  var minuteur = null;
  new MutationObserver(function () {
    if (minuteur) clearTimeout(minuteur);
    minuteur = setTimeout(majParPersonne, 60);
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();

/* Barre « Commander » collee en bas sur mobile (14 oct). Quand un pack est
   ouvert, le bouton du theme est a plus de deux ecrans du haut de la fiche.
   La barre reprend le prix de l offre choisie et clique le vrai bouton, donc
   Bundle X garde la main sur l ajout au panier. Elle se cache quand le vrai
   bouton est a l ecran ou tant que la cliente n a pas commence a defiler. */
(function () {
  if (!window.IntersectionObserver) return;

  function init() {
    var cta = document.querySelector('button.buy-cta');
    if (!cta || document.querySelector('.yk-sticky')) return;

    var barre = document.createElement('div');
    barre.className = 'yk-sticky';
    barre.innerHTML = '<span class="yk-sticky__prix"></span><button type="button" class="yk-sticky__btn">Commander</button>';
    document.body.appendChild(barre);
    var prix = barre.querySelector('.yk-sticky__prix');

    function majPrix() {
      var p = document.querySelector('.bx-offer-wrap.bx-active .bx-offer-main > .bx-offer-items > .bx-offer-prices .bx-discounted-price');
      var t = p ? p.textContent.trim() : '';
      if (prix.textContent !== t) prix.textContent = t;
    }
    function majPrixBientot() { setTimeout(majPrix, 120); setTimeout(majPrix, 600); }

    var boutonVisible = true;
    function maj() {
      barre.classList.toggle('yk-sticky--on', !boutonVisible && window.scrollY > 300);
    }
    new IntersectionObserver(function (e) { boutonVisible = e[0].isIntersecting; maj(); }).observe(cta);
    window.addEventListener('scroll', maj, { passive: true });
    document.addEventListener('click', majPrixBientot, true);
    document.addEventListener('change', majPrixBientot, true);
    barre.querySelector('button').addEventListener('click', function () { cta.click(); });
    majPrix(); setTimeout(majPrix, 1500); setTimeout(majPrix, 4000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
